import { GET_ALL_RADIOS, ADD_RADIO, UPDATE_RADIO } from '../types'

const INITIAL_STATE = {
  allRadios: [],
  addRadios: [],
  updateRadio: [],
}

const radioReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_RADIOS:
      return {
        ...state,
        allRadios: payload,
      }
    case ADD_RADIO:
      return {
        ...state,
        addRadios: payload,
      }
    case UPDATE_RADIO:
      return {
        ...state,
        updateRadio: payload.id,
      }
    default:
      return state
  }
}

export default radioReducer
